var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 63.5,
  y: 63.5,
  width: 63,
  height: 63,
  rx: 31.5,
  transform: "rotate(-180 63.5 63.5)",
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3929 31.0591L30.765 17.3436L32.1002 16L48 31.9994L32.1002 48L30.765 46.5875L44.3871 32.9412H16.0005V31.0591L44.3929 31.0591Z",
  fill: "#001246"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 63.5,
  y: 63.5,
  width: 63,
  height: 63,
  rx: 31.5,
  transform: "rotate(-180 63.5 63.5)",
  stroke: "black"
})));
export default SvgArrowNext;